import request from '@/utils/request'

let RankApi = {
    /*获取数据*/
    getSetting(data, errorback) {
        return request._get('/shop/plus.rank.Rank/getSetting', data, errorback);
    },
    setSetting(data, errorback) {
        return request._post('/shop/plus.rank.Rank/setSetting', data, errorback);
    },
    queryRedpageRank(data, errorback) {
        return request._post('/shop/plus.rank.Rank/queryRedpageRank', data, errorback);
    },
    queryFansRank(data, errorback) {
        return request._post('/shop/plus.rank.Rank/queryFanRank', data, errorback);
    }


}
export default RankApi;


// WEBPACK FOOTER //
// ./src/api/rank.js